import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { WorkflowStep } from 'app/models/workflow-step';
import { FormGroup, FormArray } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { DeleteStepCompletionComponent } from '../../delete-step-completion/delete-step-completion.component';

@Component({
  selector: 'app-step-completion-details',
  templateUrl: './step-completion-details.component.html',
  styleUrls: ['./step-completion-details.component.scss']
})
export class StepCompletionDetailsComponent implements OnInit {

  @Output() hideModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() stepCompletionDeleted: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('stepCompletionDetailsModal') stepCompletionDetailsModal: ModalDirective;
  @ViewChild('deleteStepCompletionComponent', {static: false}) deleteStepCompletionComponent: DeleteStepCompletionComponent;

  currentStepCompletionFormGroup: FormGroup;

  constructor(public workflowWizardService: WorkflowWizardService,
    private _router: Router) { }

  ngOnInit() {
  }

  show(currentStepCompletionFormGroup: FormGroup) {
    this.currentStepCompletionFormGroup = currentStepCompletionFormGroup;
    if (!this.stepCompletionDetailsModal.isShown)
      this.stepCompletionDetailsModal.show();
  }

  hide() {
    if (this.stepCompletionDetailsModal.isShown)
      this.stepCompletionDetailsModal.hide();
  }

  onEditStepMaterials() {
    this.hide();
    this.workflowWizardService.currentStep = this.currentStepCompletionFormGroup.parent.parent as FormGroup;
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP;
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP}`);
  }

  onEditStepAutoActions() {
    this.hide();
    this.workflowWizardService.currentStep = this.currentStepCompletionFormGroup.parent.parent as FormGroup;
    this.workflowWizardService.currentStepURL = this.workflowWizardService.WIZARD_NEW_STEP_RULES;
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_NEW_STEP_RULES}`);
  }
}
